import { getJson } from "../../../api/http";
import { ListSummaryDTO } from "../types/ftp_automation_types";

const FTPAUTO_BASE = (process.env.REACT_APP_FTPAUTOMATION_API_URL ?? "").replace(/\/+$/, "");

function build(path: string) {
  return path.startsWith("http") ? path : `${FTPAUTO_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}

export function fetchListSummaries(signal?: AbortSignal): Promise<ListSummaryDTO[]> {
  return getJson<ListSummaryDTO[]>(build("/List/summaries"), { signal });
}